import React, { useEffect, useState } from 'react';
import DialogComponent from '../../../components/dialog/dialog.component';
import { TrapeziumButton } from '../../../components/buton-trapezium';
import { CustomDropdown } from './custom-dropdown';
import { EmptyComponent } from '../../../components/empty/empty-component';
import { ITopDonator, ITopFollower } from '../../../models/leaderboard.model';
import {
  fetchTopDonatorApi,
  fetchTopFollowerApi,
  fetchTopReceiversApi,
} from '../../../api/user-profile/leaderboard';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import top1 from '../../../images/profile/top1.png';
import top2 from '../../../images/profile/top2.png';
import top3 from '../../../images/profile/top3.png';
import top4 from '../../../images/profile/top4.png';
import top5 from '../../../images/profile/top5.png';
import top6 from '../../../images/profile/top-6.png';
import top7 from '../../../images/profile/top-7.png';
import top8 from '../../../images/profile/top-8.png';
import top9 from '../../../images/profile/top-9.png';

interface IDialogTop {
  open: boolean;
  handleClose: () => void;
  activeTabCurrent: string;
  monthCurrent: number;
  current: boolean;
}
export const DialogTop = ({
  open,
  activeTabCurrent,
  monthCurrent,
  current,
  handleClose,
}: IDialogTop) => {
  const [month, setMonth] = useState<number>(monthCurrent);
  const [activeTab, setActiveTab] = useState(activeTabCurrent);
  const [isCurrent, setIsCurrent] = useState<boolean>(true);
  const [topReceivers, setTopReceivers] = useState<ITopDonator>({
    totalItems: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    items: [],
  });
  const [topDonator, setTopDonator] = useState<ITopDonator>({
    totalItems: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    items: [],
  });
  const [topFollower, setTopFollower] = useState<ITopFollower>({
    total: 0,
    hasNext: false,
    data: [],
  });
  useEffect(() => {
    setActiveTab(activeTabCurrent);
  });
  useEffect(() => {
    const fetchTopDonator = async (params?: {
      startTime?: string;
      endTime?: string;
    }) => {
      try {
        const responses = await fetchTopDonatorApi(params);
        setTopDonator(responses);
      } catch (error) {
        console.error('Failed to fetch leaderboard:', error);
      }
    };
    if (activeTab === 'donator') {
      if (isCurrent) {
        fetchTopDonator();
      } else {
        const currentYear = dayjs().year();
        const formattedMonth = `${currentYear}-${String(month).padStart(
          2,
          '0'
        )}`;
        const startTime = dayjs(`${formattedMonth}-01`)
          .startOf('month')
          .format('YYYY-MM-DD');
        const endTime = dayjs(`${formattedMonth}-01`)
          .endOf('month')
          .format('YYYY-MM-DD');
        fetchTopDonator({ startTime, endTime });
      }
    }

    const fetchFollower = async (params?: {
      startTime?: string;
      endTime?: string;
    }) => {
      try {
        const responses = await fetchTopFollowerApi(params);
        setTopFollower(responses);
      } catch (error) {
        console.error('Failed to fetch leaderboard:', error);
      }
    };
    if (activeTab === 'followers') {
      if (isCurrent) {
        fetchFollower();
      } else {
        const currentYear = dayjs().year();
        const formattedMonth = `${currentYear}-${String(month).padStart(
          2,
          '0'
        )}`;
        const startTime = dayjs(`${formattedMonth}-01`)
          .startOf('month')
          .format('YYYY-MM-DD');
        const endTime = dayjs(`${formattedMonth}-01`)
          .endOf('month')
          .format('YYYY-MM-DD');
        fetchFollower({ startTime, endTime });
      }
    }

    const fetchReceivers = async (params?: {
      startTime?: string;
      endTime?: string;
    }) => {
      try {
        const responses = await fetchTopReceiversApi(params);
        setTopReceivers(responses);
      } catch (error) {
        console.error('Failed to fetch leaderboard:', error);
      }
    };
    if (activeTab === 'receives') {
      if (isCurrent) {
        fetchReceivers();
      } else {
        const currentYear = dayjs().year();
        const formattedMonth = `${currentYear}-${String(month).padStart(
          2,
          '0'
        )}`;
        const startTime = dayjs(`${formattedMonth}-01`)
          .startOf('month')
          .format('YYYY-MM-DD');
        const endTime = dayjs(`${formattedMonth}-01`)
          .endOf('month')
          .format('YYYY-MM-DD');
        fetchReceivers({ startTime, endTime });
      }
    }
  }, [isCurrent, activeTab, month]);

  return (
    <DialogComponent
      placement="CENTER"
      size="full"
      customSize="max-w-[954px] w-full"
      visible={open}
    >
      <div className="flex flex-col  bg-white rounded-xl">
        <div className="flex items-center p-3 justify-between w">
          <div className="flex items-center gap-4">
            <h4 className="text-[#18191E] text-[22px] leading-6 dark:text-zinc-50 text-xl font-semibold mr-3">
              {activeTab === 'donator' && 'Top Donate'}
              {activeTab === 'followers' && 'Top Follower'}
              {activeTab === 'receives' && 'Top Receives'}
              {activeTab === 'react' && 'Top tương tác'}
            </h4>
            {!isCurrent && (
              <div className="w-[274px]">
                <CustomDropdown
                  disable={isCurrent}
                  value={month.toString()}
                  options={Array.from({ length: 12 }, (_, i) => ({
                    label: `Tháng ${i + 1}`,
                    value: `${i + 1}`,
                  }))}
                  placeholder="Tháng"
                  customClassName="py-2 h-10 px-3 text-base w-[274px] font-semibold"
                  onChange={(val) => setMonth(Number(val))}
                />
              </div>
            )}
          </div>
          <div className="flex items-center gap-4">
            <TrapeziumButton
              onClick={() => {
                setIsCurrent(!isCurrent);
              }}
            >
              <span className="skew-x-[20deg]">
                {isCurrent ? 'Top hiện tại' : 'Top tháng'}
              </span>
            </TrapeziumButton>
            <button
              type="button"
              className="text-xl text-zinc-900 dark:text-zinc-50 font-semibold ml-auto"
              onClick={handleClose}
            >
              <svg
                width="41"
                height="40"
                viewBox="0 0 41 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="40" height="40" rx="20" fill="#EAEFFA" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M27.7803 12.7197C28.0732 13.0126 28.0732 13.4874 27.7803 13.7803L14.2803 27.2803C13.9874 27.5732 13.5126 27.5732 13.2197 27.2803C12.9268 26.9874 12.9268 26.5126 13.2197 26.2197L26.7197 12.7197C27.0126 12.4268 27.4874 12.4268 27.7803 12.7197Z"
                  fill="#657384"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.2197 12.7197C13.5126 12.4268 13.9874 12.4268 14.2803 12.7197L27.7803 26.2197C28.0732 26.5126 28.0732 26.9874 27.7803 27.2803C27.4874 27.5732 27.0126 27.5732 26.7197 27.2803L13.2197 13.7803C12.9268 13.4874 12.9268 13.0126 13.2197 12.7197Z"
                  fill="#657384"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="py-3 bg-red-50 min-h-[596px] flex justify-center items-center">
          {activeTab === 'followers' ? (
            topFollower.data.length > 0 ? (
              <div className="grid gap-3 py-3 max-w-[560px] mx-auto">
                <div className="grid grid-cols-1 place-items-center">
                  <div
                    key={topFollower.data[0].userId}
                    className="h-[100px] relative aspect-[274/100] px-[18px] pt-[23px]"
                  >
                    <div className="flex w-full flex-col text-[#111827]  relative z-[2]">
                      <span className="text-xs font-baloo leading-5 font-extrabold">
                        Top 1
                      </span>
                      <Link to={`/user/${topFollower.data[0]?.userName}`}>
                        <span className="text-base leading-5 uppercase">
                          {topFollower.data[0]?.userName}
                        </span>
                      </Link>
                      <div className="text-base font-baloo font-extrabold">
                        {topFollower.data[0]?.totalFollow} Followers
                      </div>
                    </div>

                    <div className="absolute inset-0">
                      <img src={top1} alt="top-1" className="w-full h-full" />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {topFollower.data.slice(1, 9).map((item, index) => (
                    <div
                      key={item.userId}
                      className="h-[100px] relative aspect-[274/100] px-[18px] pt-[23px]"
                    >
                      <div className="flex w-full flex-col text-[#111827] relative z-[2]">
                        <span className="text-xs font-baloo leading-5 font-extrabold">
                          Top {index + 2}
                        </span>
                        <Link to={`/user/${item?.userName}`}>
                          <span className="text-base leading-5 uppercase">
                            {item.userName}
                          </span>
                        </Link>
                        <div className="text-base font-baloo font-extrabold">
                          {item?.totalFollow} Followers
                        </div>
                      </div>

                      <div className="absolute inset-0">
                        <img
                          src={
                            [top2, top3, top4, top5, top6, top7, top8, top9][
                              index
                            ]
                          }
                          alt={`top-${index + 2}`}
                          className="w-full h-full"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <EmptyComponent />
            )
          ) : null}

          {activeTab === 'receives' ? (
            topReceivers.items.length > 0 ? (
              <div className="grid gap-3 py-3 max-w-[560px] mx-auto">
                <div className="grid grid-cols-1 place-items-center">
                  <div
                    key={topReceivers.items[0].userId}
                    className="h-[100px] relative aspect-[274/100] px-[18px] pt-[23px]"
                  >
                    <div className="flex w-full flex-col text-[#111827]  relative z-[2]">
                      <span className="text-xs font-baloo leading-5 font-extrabold">
                        Top 1
                      </span>
                      <Link to={`/user/${topReceivers.items[0]?.userName}`}>
                        <span className="text-base leading-5 uppercase">
                          {topReceivers.items[0]?.userName}
                        </span>
                      </Link>
                      <div className="text-base font-baloo font-extrabold">
                        {`${topReceivers.items[0].totalAmount}`.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          '.'
                        )}{' '}
                        Ca
                      </div>
                    </div>

                    <div className="absolute inset-0">
                      <img src={top1} alt="top-1" className="w-full h-full" />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {topReceivers.items.slice(1, 9).map((item, index) => (
                    <div
                      key={item.userId}
                      className="h-[100px] relative aspect-[274/100] px-[18px] pt-[23px]"
                    >
                      <div className="flex w-full flex-col text-[#111827] relative z-[2]">
                        <span className="text-xs font-baloo leading-5 font-extrabold">
                          Top {index + 2}
                        </span>
                        <Link to={`/user/${item?.userName}`}>
                          <span className="text-base leading-5 uppercase">
                            {item.userName}
                          </span>
                        </Link>
                        <div className="text-base font-baloo font-extrabold">
                          {`${item?.totalAmount}`.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            '.'
                          )}{' '}
                          Ca
                        </div>
                      </div>

                      <div className="absolute inset-0">
                        <img
                          src={
                            [top2, top3, top4, top6, top7, top8, top9, top5][
                              index
                            ]
                          }
                          alt={`top-${index + 2}`}
                          className="w-full h-full"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <EmptyComponent />
            )
          ) : null}

          {activeTab === 'donator' ? (
            topDonator.items.length > 0 ? (
              <div className="grid gap-3 py-3 max-w-[560px] mx-auto">
                <div className="grid grid-cols-1 place-items-center">
                  <div
                    key={topDonator.items[0].userId}
                    className="h-[100px] relative aspect-[274/100] px-[18px] pt-[23px]"
                  >
                    <div className="flex w-full flex-col text-[#111827] relative z-[2]">
                      <span className="text-xs font-baloo leading-5 font-extrabold">
                        Top 1
                      </span>
                      <Link to={`/user/${topDonator.items[0]?.userName}`}>
                        <span className="text-base leading-5 uppercase">
                          {topDonator.items[0]?.userName}
                        </span>
                      </Link>
                      <div className="text-base font-baloo font-extrabold">
                        {`${topDonator.items[0].totalAmount}`.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          '.'
                        )}{' '}
                        Ca
                      </div>
                    </div>

                    <div className="absolute inset-0">
                      <img src={top1} alt="top-1" className="w-full h-full" />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {topDonator.items.slice(1, 9).map((item, index) => (
                    <div
                      key={item.userId}
                      className="h-[100px] relative aspect-[274/100] px-[18px] pt-[23px]"
                    >
                      <div className="flex w-full flex-col text-[#111827] relative z-[2]">
                        <span className="text-xs font-baloo leading-5 font-extrabold">
                          Top {index + 2}
                        </span>
                        <Link to={`/user/${item?.userName}`}>
                          <span className="text-base leading-5 uppercase">
                            {item.userName}
                          </span>
                        </Link>
                        <div className="text-base font-baloo font-extrabold">
                          {`${item.totalAmount}`.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            '.'
                          )}{' '}
                          Ca
                        </div>
                      </div>

                      <div className="absolute inset-0">
                        <img
                          src={
                            [top2, top3, top4, top6, top7, top8, top9, top5][
                              index
                            ]
                          }
                          alt={`top-${index + 2}`}
                          className="w-full h-full"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <EmptyComponent />
            )
          ) : null}
        </div>
        <div className="h-[56px]" />
      </div>
    </DialogComponent>
  );
};
